import { action, makeAutoObservable, runInAction } from 'mobx';
import { IAccountModel } from '../../../models/Account';
import { FEATURES } from '../../../models/Plan';
import AccountService from '../../../services/api/account-service';
import { rootContainer, TYPE } from '../../../services/container/root';
import currentPortalStore from '../../../stores/current-portal-store';
import AccountEditorStore from './account-editor-store';
import currentAccountStore from './current-account-store';

class AccountListStore {
	private _list: AccountEditorStore[] = [];
	private _quota: number = -1;

	constructor() {
		makeAutoObservable(this);
	}

	private get service(): AccountService {
		return rootContainer.get<AccountService>(TYPE.AccountService);
	}

	private _currentAccountId?: number|string;

	public get currentAccount() {
		return this._list.find(i => i.isIdEquals(this._currentAccountId));
	}

	private _isLoading: boolean = false;

	get isLoading() {
		return this._isLoading;
	}

	get quota() {
		return this._quota;
	}

	get list() {
		/** filtering out draft (new, not yet saved account) from the list */
		return this._list.filter(i => !i.isNew);
	}

	public setCurrentAccount(id: number|string) {
		this._currentAccountId = id;
	}

	public setNewAccount(): string {
		const newAccount = new AccountEditorStore(undefined, false);
		this._currentAccountId = newAccount.id;
		this._list = [...this._list, newAccount];
		return this._currentAccountId as string;
	}

	public dropCurrentAccount() {
		this._currentAccountId = undefined;
		this._list = this._list.filter(i => !i.isNew);
	}

	public get canEnable(): boolean {
        return this._quota > this.getActiveAccountsTotal()
    }

	@action
	async load() {
		this._isLoading = true;
		let list:IAccountModel[];

		try {
			[list] = await Promise.all([this.service.fetchList(), currentAccountStore.load(), currentPortalStore.loadFeatures([FEATURES.USERS])]);
		}
		catch {}

		runInAction(() => {
			if (list) {
				this._list = list.map(model => new AccountEditorStore(
					model,
					currentAccountStore.account?.id === model.id
				));
				this._quota = currentPortalStore.getFeatureQuota(FEATURES.USERS);
			}
			this._isLoading = false;
		});
	}

	public getActiveAccountsTotal(): number {
		return this._list.filter(a => a.is_enabled).length;
	}
}


export default new AccountListStore();